export default __webpack_public_path__ + "static/media/bamboo-New.27df9af4.png";